import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Project } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editProjectAllocatedResourcesBudget(
    request: Boundaries["editProjectAllocatedResourcesBudget"]["request"],
  ): void;
}

function useEditProjectAllocatedResourcesBudget(
  project: Identifiable<Project>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditProjectAllocatedResourcesBudgetRequestPending(project),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditProjectAllocatedResourcesBudgetRequestSuccess(project),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditProjectAllocatedResourcesBudgetRequestFailure(project),
    ),
    editProjectAllocatedResourcesBudget:
      core.editProjectAllocatedResourcesBudget,
  };
}

export { useEditProjectAllocatedResourcesBudget };
